import { theme } from "../../styles/theme";

export const variations = {
	purple: {
		color: theme.colors["vivid-04"], // #7D72FF
		bgOverlay: theme.colors["background-02"],
	},
	blue: {
		color: theme.colors["vivid-03"], // #0AE1FF
		bgOverlay: theme.colors["background-02"],
	},
	green: {
		color: theme.colors["vivid-02"], // #9FE870
		bgOverlay: theme.colors["background-02"],
	},
	yellow: {
		color: theme.colors["vivid-01"], // #CEFF00
		bgOverlay: theme.colors["background-02"],
	},
};
